/**
 * Sentinel ids for the non-data virtual rows in the narrative list (pinned
 * divider + edge loaders). Negative so they can never collide with a real
 * narrative id (which are always positive), and each is distinct so the
 * virtualizer keys stay stable across renders.
 *
 * Where each row sits in the combined virtual list (top → bottom):
 *
 *   DESC (newest at top)          ASC (newest at bottom)
 *   --------------------          ----------------------
 *   pinned rows                   OLDER_LOADER   (-3)
 *   PINNED_DIVIDER (-1)           data (oldest -> newest)
 *   NEWER_LOADER   (-2)           NEWER_LOADER   (-2)
 *   data (newest -> oldest)       PINNED_DIVIDER (-1)
 *   OLDER_LOADER   (-3)           pinned rows
 *
 * The `newer` loader is always adjacent to the newest entry (just past the
 * pinned section); the `older` loader is always at the far/oldest end.
 */
export const PINNED_DIVIDER_ROW_ID = -1 as const;
export const NEWER_LOADER_ROW_ID = -2 as const;
export const OLDER_LOADER_ROW_ID = -3 as const;

/** `data-testid` of AdditionalInfoRenderer's scroll viewport. */
export const ADDITIONAL_INFOS_SCROLL_CONTAINER_TESTID = 'ADDITIONAL_INFOS_SCROLL_CONTAINER';

/**
 * FR renders the jump buttons (NarrativeJumpButtons) as an overlay on top of
 * the scroll container instead of a separate flex column, so the container's
 * own scrollbar-gutter sits flush with the panel's true right edge rather
 * than being pushed inward. The buttons are a fixed-size element (always one
 * lg IconButton column, or not rendered at all) — not data-driven — so the
 * reserved clearance is a token-driven constant rather than something
 * measured at runtime. --arc-sizes-control-lg is the same token
 * additional-info-row.module.css and pinned-narrative-row.module.css already
 * use to size a row around an lg control, which is what NarrativeJumpButtons
 * renders at isFirstResponder. Rows already carry their own small
 * margin-right buffer, so no extra gap is added here.
 */
export const FR_JUMP_BUTTONS_RESERVED_WIDTH = 'var(--arc-sizes-control-lg)';
